import styled from 'styled-components';

export const StyledPasswordStrength = styled.span<{ strength: string }>`
font-weight: bold;  
color: ${({ strength, theme }) => {
    switch (strength) {
      case 'PasswordStrenghClassStrong':
        return theme.colors.green14;
      case 'PasswordStrenghClassVeryStrong':
        return theme.colors.green10;
      default:
        return theme.colors.red14;
    }
  }};
`;
